import * as React from 'react';
export const IcSnake = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.5 17H18V5.5c0-.83-.67-1.5-1.5-1.5h-5c-.83 0-1.5.67-1.5 1.5V17H7v-5.61c.61-.55 1-1.41 1-2.39 0-1.43-.83-2.62-1.95-2.92.03-.11.05-.22.11-.32.13-.25.3-.47.49-.67.08-.08.16-.17.21-.27.08-.18.05-.41-.09-.55a.517.517 0 00-.54-.12c-.12.05-.21.14-.29.23-.15.16-.28.33-.4.51h-.02c-.11-.17-.21-.36-.34-.53a.92.92 0 00-.26-.26c-.17-.1-.4-.07-.55.05-.15.12-.21.35-.15.54.04.11.11.2.18.3.17.22.32.45.41.71.04.13.07.26.08.4-1.09.33-1.9 1.5-1.9 2.91 0 .98.4 1.84 1 2.39v7.11c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5V7h2v11.5c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h.01z'
      fill='currentColor'
    />
  </svg>
);
